import { useState } from 'react'
import { useAuth } from '../../context/AuthContext'
import { useNavigate } from 'react-router-dom'

export default function Login() {
  const [isSignUp, setIsSignUp] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [fullName, setFullName] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState('')

  const { signIn, signUp } = useAuth()
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setSuccess('')
    setLoading(true)
    try {
      if (isSignUp) {
        await signUp(email, password, fullName)
        setSuccess('Registrasi berhasil! Cek email untuk verifikasi.')
        setIsSignUp(false)
      } else {
        await signIn(email, password)
        navigate('/')
      }
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'var(--bg-primary)', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 380, background: 'var(--bg-secondary)', borderRadius: 'var(--radius-lg)', border: '1px solid var(--border)', overflow: 'hidden', boxShadow: '0 16px 48px rgba(0,0,0,.5)' }}>

        {/* Header */}
        <div style={{ background: 'var(--bg-tertiary)', borderBottom: '1px solid var(--border)', padding: '24px 28px', textAlign: 'center' }}>
          <img src="/logo.png" alt="Undagi Logo" style={{ width: 56, height: 56, objectFit: 'contain', marginBottom: 12 }} />
          <h1 style={{ fontSize: 22, fontWeight: 900, color: 'var(--accent)', letterSpacing: '-0.5px' }}>Undagi</h1>
          <p style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 2 }}>Manajemen Proyek Konstruksi</p>
        </div>

        {/* Form */}
        <div style={{ padding: '28px' }}>
          <h2 style={{ fontSize: 16, fontWeight: 700, marginBottom: 20, textAlign: 'center' }}>
            {isSignUp ? '📝 Daftar Akun' : '👋 Masuk ke Undagi'}
          </h2>

          {error && (
            <div style={{ background: 'var(--danger-bg)', border: '1px solid var(--danger)', color: 'var(--danger)', borderRadius: 'var(--radius)', padding: '8px 12px', marginBottom: 14, fontSize: 12, fontWeight: 500 }}>
              ⚠️ {error}
            </div>
          )}
          {success && (
            <div style={{ background: 'var(--success-bg)', border: '1px solid var(--success)', color: 'var(--success)', borderRadius: 'var(--radius)', padding: '8px 12px', marginBottom: 14, fontSize: 12, fontWeight: 500 }}>
              ✅ {success}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            {isSignUp && (
              <div className="form-group">
                <label className="form-label">Nama Lengkap</label>
                <input
                  className="form-input"
                  type="text"
                  value={fullName}
                  onChange={e => setFullName(e.target.value)}
                  placeholder="Nama anda"
                  required
                />
              </div>
            )}

            <div className="form-group">
              <label className="form-label">Email</label>
              <input
                className="form-input"
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="nama@email.com"
                required
              />
            </div>

            <div className="form-group">
              <label className="form-label">Password</label>
              <input
                className="form-input"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="Minimal 6 karakter"
                minLength={6}
                required
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: '100%', marginTop: 8, padding: '11px', fontSize: 14 }}
              disabled={loading}
            >
              {loading ? '⏳ Proses...' : isSignUp ? '📝 Daftar' : '🔐 Masuk'}
            </button>
          </form>

          <div style={{ textAlign: 'center', marginTop: 16, fontSize: 12, color: 'var(--text-muted)' }}>
            {isSignUp ? 'Sudah punya akun?' : 'Belum punya akun?'}{' '}
            <span
              style={{ color: 'var(--accent)', cursor: 'pointer', fontWeight: 600 }}
              onClick={() => { setIsSignUp(!isSignUp); setError(''); setSuccess('') }}
            >
              {isSignUp ? 'Masuk' : 'Daftar Gratis'}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}